import { useMutation, useQueryClient } from "@tanstack/react-query"
import { useNavigate } from "react-router-dom"
import Swal from "sweetalert2"
import { saveSupplierInfo, updateClientStatus } from "../services/reviewForAuth.service"

export const useReviewForAuthMutations = ({ id, userLogged }) => {
	const queryClient = useQueryClient()
	const navigate = useNavigate()
	const queryKey = ['supplier-reviewForAuth', id]

	const saveInfoMutation = useMutation({
		mutationFn: ({ supplier }) =>
			saveSupplierInfo({ supplier, id }),
		onMutate: () => {
			Swal.fire({
				toast: true,
				footer: 'Loading, please wait',
				showConfirmButton: false,
				position: "bottom-end",
				didOpen: () => {
					Swal.showLoading()
				},
			})
		},
		onSuccess: (data, variables) => {
			Swal.fire({
				toast: true,
				icon: 'success',
				text: 'Supplier updated successfully',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
				position: "bottom-end",
			})
			queryClient.invalidateQueries({ queryKey })
		},
		onError: (err) => {
			Swal.fire({
				toast: true,
				icon: 'error',
				text: 'Failed to update supplier',
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
				position: "bottom-end",
			})
			console.log("Error al autorizar el supplier: " + err)
		},
	})

	const statusChangeMutation = useMutation({
		mutationFn: ({ clientID, newStatus }) =>
			updateClientStatus({ id, clientID, newStatus, username: userLogged?.username, dataID: userLogged?.dataID, rol: userLogged?.rol }),
		onMutate: () => {
			Swal.fire({
				toast: true,
				footer: 'Loading, please wait',
				showConfirmButton: false,
				position: "bottom-end",
				didOpen: () => {
					Swal.showLoading()
				},
			})
		},
		onSuccess: (data, variables) => {
			Swal.fire({
				toast: true,
				icon: 'success',
				text: 'Supplier updated successfully',
				showConfirmButton: false,
				timer: 2000,
				timerProgressBar: true,
				position: "bottom-end",
			})
			queryClient.invalidateQueries({ queryKey })
			const { newStatus } = variables
			if (newStatus === "Active" || newStatus === "Authorized" || newStatus === "Rejected" || newStatus === "Review requested") {
				navigate(-1)
			}
		},
		onError: (err) => {
			Swal.fire({
				toast: true,
				icon: 'error',
				text: 'Failed to update supplier',
				showConfirmButton: false,
				timer: 3000,
				timerProgressBar: true,
				position: "bottom-end",
			})
			console.log("Error al autorizar el supplier: " + err)
		},
	})

	const handleSaveInfo = (updatedSupplier) => {
		return saveInfoMutation.mutateAsync({ supplier: updatedSupplier })
	}

	const handleStatusChange = (clientID, newStatus) => {
		return statusChangeMutation.mutateAsync({ clientID, newStatus })
	}

	const handleUpdateSupplierStatus = (supplier, clientID, status) => {
		return handleStatusChange(clientID, status)
	}

	return { handleSaveInfo, handleStatusChange, handleUpdateSupplierStatus }
}
